/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Self_Organize_DisabledInputs */



/**
* | output |
* | --- |
* | "Self-organized rounds are not enabled for this tournament" |
*
* @param {Err_Tournament_Self_Organize_DisabledInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_self_organize_disabled = /** @type {((inputs?: Err_Tournament_Self_Organize_DisabledInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Self_Organize_DisabledInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les rondes auto-organisées ne sont pas activées pour ce tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las rondas autoorganizadas no están habilitadas para este torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("As rodadas auto-organizadas não estão habilitadas para este torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("I round autogestiti non sono abilitati per questo torneo")
	return /** @type {LocalizedString} */ ("Self-organized rounds are not enabled for this tournament")
});